import React from "react";
import LoansPresenter from "./LoansPresenter";
import Shell from "../../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOLoans from "./DTOLoans";
import { useTranslation } from "react-i18next";

function LoansController() {
  const { t, i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DTOLoans />
        <LoansPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default LoansController;
